import { useSlots as S, computed as o, getCurrentInstance as k, openBlock as i, createElementBlock as s, mergeProps as $, withKeys as T, renderSlot as c, createBlock as d, createCommentVNode as l, createTextVNode as I, createVNode as y, withCtx as C } from "vue";
import u from "./design-system.es58.js";
import D from "./design-system.es106.js";
import K from "./design-system.es30.js";
import { createActionsProvider as N } from "./design-system.es31.js";
/* empty css                    */
/* empty css                    */
import V from "./design-system.es128.js";
const E = {
  key: 0,
  class: "leading-slot"
}, P = {
  key: 1,
  class: "trailing-slot"
}, R = /* @__PURE__ */ Object.assign({
  name: "DsChip"
}, {
  __name: "Chip",
  props: {
    variant: {
      type: String,
      default: "default",
      options: ["default", "outline"]
    },
    leadingIcon: {
      type: String,
      default: ""
    },
    trailingIcon: {
      type: String,
      default: ""
    },
    /**
     * DEPRECATED: Shows an x icon within the chip. Attach a remove handler instead to get the same effect.
     */
    remove: Boolean,
    /**
     * DEPRECATED: Adds interaction effects, eg. hover, pressed, etc. Attach a click handler instead to get the same effect.
     */
    withInteraction: Boolean
  },
  emits: ["remove", "click"],
  setup(n, { emit: w }) {
    const a = n, r = w, m = S(), { containsEventTarget: p } = N(), v = o(() => {
      var e, t;
      return (t = (e = k()) == null ? void 0 : e.vnode.props) == null ? void 0 : t.onClick;
    }), f = o(() => m.leading || a.leadingIcon), g = o(() => {
      var e, t;
      return a.remove || ((t = (e = k()) == null ? void 0 : e.vnode.props) == null ? void 0 : t.onRemove);
    }), h = o(() => m.trailing || a.trailingIcon || g.value), b = o(() => v.value ? {
      role: "button",
      tabindex: 0
    } : {});
    function x(e) {
      (!p(e) || a.remove) && r("click", e);
    }
    function B(e) {
      p(e) || r("click", e);
    }
    return (e, t) => (i(), s("div", $(b.value, {
      class: ["ds-chip", {
        "ds-chip--with-interaction": n.withInteraction || v.value,
        "ds-chip--with-leading": f.value,
        "ds-chip--with-trailing": h.value,
        "ds-chip--outline": n.variant === "outline"
      }],
      onClick: x,
      onKeydown: T(B, ["enter"])
    }), [
      f.value ? (i(), s("div", E, [
        c(e.$slots, "leading", {}, () => [
          n.leadingIcon ? (i(), d(u, {
            key: 0,
            name: n.leadingIcon
          }, null, 8, ["name"])) : l("", !0)
        ], !0)
      ])) : l("", !0),
      t[1] || (t[1] = I()),
      y(D, {
        variant: "caption",
        class: "ds-chip-text"
      }, {
        default: C(() => [
          c(e.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }),
      t[2] || (t[2] = I()),
      h.value ? (i(), s("div", P, [
        c(e.$slots, "trailing", {}, () => [
          g.value ? (i(), d(K, {
            key: 0,
            as: "button",
            type: "button",
            class: "ds-chip-remove-button",
            onClick: t[0] || (t[0] = (j) => r("remove"))
          }, {
            default: C(() => [
              y(u, { name: "x-circle-fill" })
            ]),
            _: 1
          })) : n.trailingIcon ? (i(), d(u, {
            key: 1,
            name: n.trailingIcon
          }, null, 8, ["name"])) : l("", !0)
        ], !0)
      ])) : l("", !0)
    ], 16));
  }
}), J = /* @__PURE__ */ V(R, [["__scopeId", "data-v-2d8b4e75"]]);
export {
  J as default
};
//# sourceMappingURL=design-system.es45.js.map
